import { Route } from '@angular/router';

export const FarmRoutes: Route[] = [
  {
    path: 'farm',
    loadComponent: () => import('../pages/farm/farm.page'),
  },
  {
    path: 'farm/form',
    loadComponent: () => import('../pages/farm/farm-form/farm-form.page'),
  },
  {
    path: 'farm/form/:id',
    loadComponent: () => import('../pages/farm/farm-form/farm-form.page'),
  },
  {
    path: 'farm/:id',
    loadComponent: () => import('../pages/farm/farm-detail/farm-detail.page'),
  },
];
